/** Верхняя граница для custom_goal и bonus — MySQL INT в contest-service-v2 */
export const CONTEST_CASHBACK_MAX_INT = 999_999_999;

export const CONTEST_CASHBACK_MAX_DIGITS = 9;
